import { Fragment, useEffect, useState } from 'react';
import Countdown from 'react-countdown';


const CountdownData = () => {
    // eslint-disable-next-line
    const [style, setStyle] = useState('');
    useEffect(() => {
        setTimeout(function () {
            setStyle({ style: { display: 'none' } });
        }, 1000);
    }, []);
    const Completionist = () => <span>{'You are good to go!'}</span>;

    const renderer = ({ total, days, hours, minutes, seconds, milliseconds, completed }) => {
        if (completed) {
            return <Completionist />;
        } else {
            return <div>
                <ul>
                    <li>
                        <span id="days" className="time digits">{days}</span>
                        <span className="title">{'Ngày'}</span>
                    </li>
                    <li>
                        <span className="time digits" id="hours">{hours}</span>
                        <span className="title">{'Giờ'}</span>
                    </li>
                    <li>
                        <span className="time digits" id="minutes">{minutes}</span>
                        <span className="title">{'Phút'}</span>
                    </li>
                    <li>
                        <span className="time digits" id="seconds">{seconds}</span>
                        <span className="title">{'Giây'}</span>
                    </li>
                </ul>
            </div>;
        }
    };

    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var coundown = new Date(year, month, day + 30).getTime();

    return (
        <Fragment>
            <Countdown date={coundown} renderer={renderer} />
        </Fragment>
    );
};

export default CountdownData;